// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderCommon_header__md2lF {
  height: 10vh;
  display: flex;
  align-items: center;
  background-color: var(--white-1);
  color: var(--bg-primary);
  padding: 0 40px 0 40px;
  margin-top: 3% !important;
}

.HeaderCommon_titleSectionContainer__nDaWG {
  width: 100%;
}
.HeaderCommon_cartelambienteprueba__1PKfU{
  padding-top: 5px;
  align-items: center;
  font-family: Inter;
  line-height: 20px;
  background-color: red;
  color: white;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px; 
  width: 98%;
  margin-right: 30px;
  height: 35px;
}
.HeaderCommon_textAlerta__8w6cw{
  font-weight: bold;
  padding-left: 10px;
  font-size: 13px;
  margin: 0px;
}
.HeaderCommon_textProd__E\\+qjf{
  padding-left: 10px;
  font-size: 12px
}
.HeaderCommon_pageTitleContainer__h1CB6 {
  display: flex;
  flex-direction: row;
  margin-bottom: -1rem;
  width: fit-content;
}

.HeaderCommon_pageSection__GoNpx {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: var(--bg-primary);
  margin-top: -0.35rem;
}

.HeaderCommon_arrowRight__4T57a {
  font-weight: 700 !important;
  font-size: 0.9rem !important;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.HeaderCommon_pageTitle__4IrfP {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  color: var(--bg-primary);
  margin-bottom: -0.1rem;
}

.HeaderCommon_date__zN\\+db {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 17px;
  color: var(--form-btn-cancel);
}
`, "",{"version":3,"sources":["webpack://./src/components/header/headerCommon/HeaderCommon.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".header {\r\n  height: 10vh;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: var(--white-1);\r\n  color: var(--bg-primary);\r\n  padding: 0 40px 0 40px;\r\n  margin-top: 3% !important;\r\n}\r\n\r\n.titleSectionContainer {\r\n  width: 100%;\r\n}\r\n.cartelambienteprueba{\r\n  padding-top: 5px;\r\n  align-items: center;\r\n  font-family: Inter;\r\n  line-height: 20px;\r\n  background-color: red;\r\n  color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-bottom: 8px; \r\n  width: 98%;\r\n  margin-right: 30px;\r\n  height: 35px;\r\n}\r\n.textAlerta{\r\n  font-weight: bold;\r\n  padding-left: 10px;\r\n  font-size: 13px;\r\n  margin: 0px;\r\n}\r\n.textProd{\r\n  padding-left: 10px;\r\n  font-size: 12px\r\n}\r\n.pageTitleContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-bottom: -1rem;\r\n  width: fit-content;\r\n}\r\n\r\n.pageSection {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 22px;\r\n  color: var(--bg-primary);\r\n  margin-top: -0.35rem;\r\n}\r\n\r\n.arrowRight {\r\n  font-weight: 700 !important;\r\n  font-size: 0.9rem !important;\r\n  padding-left: 0.2rem;\r\n  padding-right: 0.2rem;\r\n}\r\n\r\n.pageTitle {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  color: var(--bg-primary);\r\n  margin-bottom: -0.1rem;\r\n}\r\n\r\n.date {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 17px;\r\n  color: var(--form-btn-cancel);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `HeaderCommon_header__md2lF`,
	"titleSectionContainer": `HeaderCommon_titleSectionContainer__nDaWG`,
	"cartelambienteprueba": `HeaderCommon_cartelambienteprueba__1PKfU`,
	"textAlerta": `HeaderCommon_textAlerta__8w6cw`,
	"textProd": `HeaderCommon_textProd__E+qjf`,
	"pageTitleContainer": `HeaderCommon_pageTitleContainer__h1CB6`,
	"pageSection": `HeaderCommon_pageSection__GoNpx`,
	"arrowRight": `HeaderCommon_arrowRight__4T57a`,
	"pageTitle": `HeaderCommon_pageTitle__4IrfP`,
	"date": `HeaderCommon_date__zN+db`
};
export default ___CSS_LOADER_EXPORT___;
